import script from "./AsideForLinks.vue?vue&type=script&setup=true&lang=js"
export * from "./AsideForLinks.vue?vue&type=script&setup=true&lang=js"

import "./AsideForLinks.vue?vue&type=style&index=0&id=06c07181&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06c07181"]])

export default __exports__